import React, { Children } from 'react';
const BreadCrumbs = ({
  children = null,
  showAll = false
}) => {
  let content = children;
  const childrenCount = Children.count(children);
  if (!showAll && childrenCount >= 4) {
    const first = Children.toArray(children).slice(0, 1);
    const [secondToLast, last] = Children.toArray(children).slice(-2);
    content = [first, /*#__PURE__*/React.createElement("span", {
      key: "dots"
    }, "..."), secondToLast, last];
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "ebds-breadcrumbs"
  }, content);
};
export default BreadCrumbs;